export default "__VITE_ASSET__B4PJwUv4__"